package at.theatervogelweide.admin.contract.overview

import at.theatervogelweide.admin.contract.AdminResult
import kotlinx.rpc.annotations.Rpc

/** Übersicht (#24): the start screen in one call. */
@Rpc
interface OverviewService {
    suspend fun overview(): AdminResult<Overview>
}
